import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtErr } from "@/lib/api";
import { toast } from "sonner";
import AdminLayout from "@/components/AdminLayout";
import { KeyRound, Lock, ShieldCheck, Loader2 } from "lucide-react";

export default function AdminPassword() {
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) {
      toast.error("Yeni şifre en az 6 karakter olmalı");
      return;
    }
    if (next !== confirm) {
      toast.error("Yeni şifre ve onayı eşleşmiyor");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        current_password: current,
        new_password: next,
      });
      toast.success("Şifre başarıyla değiştirildi · Lütfen tekrar giriş yapın");
      localStorage.removeItem("sms_admin_token");
      setTimeout(() => nav("/admin/login"), 1200);
    } catch (err) {
      toast.error(fmtErr(err?.response?.data?.detail) || "Şifre değiştirilemedi");
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-xl">
        <div className="mb-8">
          <div className="tiny-label">Hesap</div>
          <h1 className="font-display font-black text-3xl text-slate-900 mt-1">Şifre Değiştir</h1>
          <p className="text-sm text-slate-600 mt-2">
            Güvenliğiniz için şifrenizi düzenli aralıklarla değiştirmenizi öneririz.
          </p>
        </div>

        <form onSubmit={submit} className="card-soft p-8 space-y-5" data-testid="password-form">
          <Field label="Mevcut Şifre" icon={Lock}>
            <input
              type="password"
              required
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              autoFocus
              data-testid="current-password"
              className="input-soft !pl-11"
              placeholder="••••••"
            />
          </Field>

          <Field label="Yeni Şifre" icon={KeyRound} hint="En az 6 karakter">
            <input
              type="password"
              required
              value={next}
              onChange={(e) => setNext(e.target.value)}
              data-testid="new-password"
              className="input-soft !pl-11"
              placeholder="••••••"
            />
          </Field>

          <Field label="Yeni Şifre (Onay)" icon={ShieldCheck}>
            <input
              type="password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              data-testid="confirm-password"
              className="input-soft !pl-11"
              placeholder="••••••"
            />
          </Field>

          <button
            type="submit"
            disabled={saving}
            data-testid="save-password"
            className="w-full btn-primary text-sm font-semibold py-3 rounded-xl disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />}
            Şifreyi Güncelle
          </button>

          <p className="text-[11px] text-slate-500 text-center">
            Şifre değiştikten sonra otomatik olarak çıkış yapılır.
          </p>
        </form>
      </div>
    </AdminLayout>
  );
}

function Field({ label, hint, icon: Icon, children }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="tiny-label">{label}</label>
        {hint && <span className="text-[11px] text-slate-500">{hint}</span>}
      </div>
      <div className="relative">
        {Icon && <Icon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-turq-500 pointer-events-none z-10" />}
        {children}
      </div>
    </div>
  );
}
